import { render, staticRenderFns } from "./OTZ.vue?vue&type=template&id=14fd981e&"
import script from "./OTZ.vue?vue&type=script&lang=js&"
export * from "./OTZ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports